var _defs, _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapEndPoint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "\\u042D\\u043B\\u043B\\u0438\\u043F\\u0441_345",
    x: 0,
    y: 0,
    width: 44,
    height: 44,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u041A\\u043E\\u043D\\u0435\\u0447\\u043D\\u0430\\u044F_\\u0442\\u043E\\u0447\\u043A\\u0430",
    "data-name": "\\u041A\\u043E\\u043D\\u0435\\u0447\\u043D\\u0430\\u044F \\u0442\\u043E\\u0447\\u043A\\u0430",
    transform: "translate(-350 -348)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 350, 348)",
    filter: "url(#\\u042D\\u043B\\u043B\\u0438\\u043F\\u0441_345)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\u042D\\u043B\\u043B\\u0438\\u043F\\u0441_345-2",
    "data-name": "\\u042D\\u043B\\u043B\\u0438\\u043F\\u0441 345",
    cx: 13,
    cy: 13,
    r: 13,
    transform: "translate(9 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u042D\\u043B\\u043B\\u0438\\u043F\\u0441_344",
    "data-name": "\\u042D\\u043B\\u043B\\u0438\\u043F\\u0441 344",
    transform: "translate(361 356)",
    fill: "#fff",
    stroke: "current",
    strokeWidth: 6
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 11,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 8,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapEndPoint);
export default __webpack_public_path__ + "static/media/map_end_point.66b6041d117008792f7b744e2c426487.svg";
export { ForwardRef as ReactComponent };